import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// ISO 7001 two-figure pictogram, so it is filled rather than stroked. Serves
// both Bathroom and Toilet — design settled them as one glyph.
export const RESTROOM_NODES: IconNode = [
  [
    'path',
    {
      key: 'restroom-0',
      d: 'M19.3222 10.8611L19.75 12.5389C19.8444 12.8889 20.2166 13.1 20.5888 13.0111C20.9555 12.9222 21.1777 12.5611 21.0777 12.2055L20.1944 9.38887L19.6388 7.27776L19.6333 7.2722C19.5833 7.03332 19.2555 6.86665 19.0111 6.87221C18.6944 6.87776 18.4833 6.87221 18.1611 6.87776L17.2111 6.88887H17.1388H17.1333H17.0611L16.1111 6.87776C15.7944 6.87221 15.5833 6.87221 15.2611 6.87221C15.0166 6.86665 14.6888 7.03332 14.6388 7.2722L14.6333 7.27776L14.0777 9.38887L13.1944 12.2111C13.0944 12.5666 13.3166 12.9222 13.6833 13.0166C14.05 13.1055 14.4277 12.8944 14.5222 12.5444L15.0055 10.8667L15.4777 9.01109L15.4555 10.8222L15.4611 11.6167L15.4722 13.45L15.4777 14.35V19.8444C15.4777 20.2055 15.7833 20.5055 16.1666 20.5055C16.5444 20.5055 16.85 20.2055 16.85 19.8444V13.6666H17.1333H17.1388H17.4222V19.8444C17.4222 20.2055 17.7277 20.5055 18.1055 20.5055C18.4888 20.5055 18.7944 20.2055 18.7944 19.8444V14.35L18.8 13.45L18.8111 11.6167L18.8166 10.8222L18.8555 9.12221L19.3222 10.8611Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'restroom-1',
      d: 'M17.139 6.40578C17.939 6.41133 18.589 5.76133 18.589 4.95578C18.589 4.15578 17.939 3.50022 17.139 3.49466C16.3334 3.48911 15.689 4.13911 15.689 4.94466C15.689 5.75022 16.339 6.40022 17.139 6.40578Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'restroom-2',
      d: 'M9.04445 10.9168L9.47223 12.5391C9.56667 12.8891 9.94445 13.1002 10.3111 13.0113C10.6833 12.9224 10.9 12.5613 10.8056 12.2057L9.91667 9.3835L9.36667 7.27239L9.36112 7.26683C9.30556 7.02795 8.98334 6.86128 8.73334 6.86683C8.41667 6.87239 8.20556 6.86683 7.88889 6.87239L6.93889 6.8835H6.86667H6.86112H6.78889L5.83889 6.87239C5.52223 6.86683 5.31112 6.86683 4.98889 6.86683C4.74445 6.86128 4.41667 7.02795 4.36667 7.26683L4.36112 7.27239L3.80556 9.3835L2.92223 12.2057C2.82778 12.5613 3.04445 12.9168 3.41667 13.0113C3.78334 13.1002 4.16112 12.8891 4.25 12.5391L4.66112 11.0279L5.26112 9.00017V9.36683L5.38334 10.8668L5.18889 11.6057L4.00556 16.0224H5.2V19.8502C5.2 20.2113 5.50556 20.5113 5.88889 20.5113C6.26667 20.5113 6.57223 20.2113 6.57223 19.8502V16.0224H7.14445V19.8502C7.14445 20.2113 7.45 20.5113 7.82778 20.5113C8.21112 20.5113 8.51667 20.2113 8.51667 19.8502V16.0224H9.75L8.53334 11.4724L8.37223 10.8668L8.49445 9.36683V9.00017L9.04445 10.9168Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'restroom-3',
      d: 'M6.86101 6.428C7.67212 6.43355 8.32212 5.778 8.32212 4.96689C8.32212 4.15578 7.66657 3.50022 6.86101 3.49466C6.0499 3.48911 5.3999 4.14466 5.3999 4.95577C5.3999 5.76689 6.0499 6.428 6.86101 6.428Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'restroom-4',
      d: 'M12.2722 3.49463H11.6833V20.4946H12.2722V3.49463Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]

export const RestroomIcon: LucideIcon = createLucideIcon(
  'restroom',
  RESTROOM_NODES,
)
